import React from 'react'
import styles from './MicrositeViewCountBadge.module.css'
import { Eye } from 'lucide-react'

/**
 * MicrositeViewCountBadge
 * Compact eye icon + formatted view count, shown on blog post
 * cards and editors.
 *
 * Usage:
 *   <MicrositeViewCountBadge count={post.viewCount} />
 */
const formatCount = (n) => {
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
    if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
    return String(n)
}

const MicrositeViewCountBadge = ({ count = 0 }) => (
    <span className={styles.badge}>
        <Eye size={12} />
        {formatCount(count)} views
    </span>
)

export default MicrositeViewCountBadge